import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section className="bg-white py-12 px-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-6 mt-8">Privacy Policy</h1>
      <p className="mb-4">Effective Date: 01/01/2025</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Data We Collect</h2>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Personal Data: Name, email, phone, address, job title, company</li>
        <li>Business Data: Project details, specifications, feedback</li>
        <li>Technical Data: IP address, device/browser info, usage analytics</li>
        <li>Payment Data: Handled securely by trusted third-party processors</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Use of Data</h2>
      <p className="mb-4">We use your data to:</p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Deliver services and manage projects</li>
        <li>Communicate updates, support, and queries</li>
        <li>Improve our services</li>
        <li>Meet legal obligations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Sharing</h2>
      <p className="mb-4">We do not sell or trade your data. We may share it with trusted service providers or legal authorities when required.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
      <p className="mb-4">We use encryption, secure servers, firewalls, and access controls to protect data.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Cookies & Tracking</h2>
      <p className="mb-4">Cookies are used to analyze site performance, customize your experience, and remember preferences.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Your Rights</h2>
      <p className="mb-4">You may:</p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Access, correct, or request deletion of your data</li>
        <li>Object to or restrict processing</li>
        <li>Withdraw consent</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Data Retention</h2>
      <p className="mb-4">We retain data only as long as necessary or as required by law.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Third-Party Links</h2>
      <p className="mb-4">We are not responsible for privacy practices of linked third-party sites.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Updates to This Policy</h2>
      <p className="mb-4">Updates will be posted on our website. Continued use indicates acceptance of changes.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p>
        Racila Softech Pvt. Ltd.<br />
        📧 <a href="mailto:support@racilasoftech.com" className="text-blue-600 underline">support@racilasoftech.com</a><br />
        📞 +91 8871787590<br />
        🌐 <a href="https://www.racilasoftech.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">www.racilaworld.com</a>
      </p>
      <footer className="mt-16 border-t border-gray-700 pt-6">
        <div className="container mx-auto text-center text-gray-500">
          <p>&copy; 2025 Racila Softech. All rights reserved.</p>
          <div className="mt-4 flex justify-center space-x-6">
            <button
              onClick={() => window.open("/privacy-policy", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => window.open("/refund-policy", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Refund Policy
            </button>
            <button
              onClick={() => window.open("/terms-conditions", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Terms & Conditions
            </button>
          </div>
        </div>
      </footer>

    </section>
  );
};

export default PrivacyPolicy;
